export default __webpack_public_path__ + "static/media/interrogation.1ab396b5.png";